'use client';

import { Children } from 'react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react'; // eslint-disable-line import/no-unresolved
import { ChevronLeft } from 'components/gruenland/icons/ChevronLeft';
import { ChevronRight } from 'components/gruenland/icons/ChevronRight';
import { NextButton } from './NextButton';
import { PrevButton } from './PrevButton';
import SliderScrollbar from './SliderScrollbar';

export type SliderNavigationProps = {
  compactNavigation?: boolean;
  arrows?: boolean;
  arrowsPosition?: 'inside' | 'outside' | 'hero';
  totalSlides?: number;
};

export type SliderProps = SwiperProps &
  SliderNavigationProps & {
    children: React.ReactNode;
    className?: string;
    dots?: boolean;
    dotsPosition?: 'outside' | 'hero';
  };

const Slider: React.FC<SliderProps> = ({
  children,
  className,
  dots,
  dotsPosition = 'outside',
  arrows,
  arrowsPosition = 'outside',
  slidesPerView = 1,
  slidesPerGroup = 1,
  ...props
}) => {
  return Children.count(children) < 2 ? (
    <>{children}</>
  ) : (
    <Swiper
      autoplay={{ delay: 5000, pauseOnMouseEnter: true }}
      modules={[Autoplay]}
      // modules={[Autoplay, Navigation, Scrollbar]}
      // navigation
      // scrollbar={{ draggable: true }}
      slidesPerView={slidesPerView}
      slidesPerGroup={slidesPerGroup}
      spaceBetween={50}
      className={className}
      {...props}
    >
      {Children.map(children, (child, index) => (
        <SwiperSlide key={index}>{child}</SwiperSlide>
      ))}

      {arrows && arrowsPosition === 'inside' && (
        <>
          <div className="absolute left-6 top-1/2 z-50 hidden size-12 translate-y-1/2 md:block">
            <PrevButton>
              <ChevronLeft width={18} />
            </PrevButton>
          </div>
          <div className="absolute right-6 top-1/2 z-50 hidden size-12 translate-y-1/2 md:block">
            <NextButton>
              <ChevronRight width={18} />
            </NextButton>
          </div>
        </>
      )}

      {arrows && arrowsPosition === 'hero' && (
        <>
          <div className="absolute inset-x-[60px] top-[680px] z-50 items-center gap-4 md:bottom-[80px] md:top-auto md:flex">
            <div className="hidden size-12 md:block">
              <PrevButton theme="white">
                <ChevronLeft width={18} color="white" />
              </PrevButton>
            </div>
            <div className="hidden size-12 md:block">
              <NextButton theme="white">
                <ChevronRight width={18} color="white" />
              </NextButton>
            </div>
            {dots && dotsPosition === 'hero' && <SliderScrollbar theme="white" className="md:ms-4" />}
          </div>
        </>
      )}

      <div className="flex items-center gap-3 pt-6">
        {arrows && arrowsPosition === 'outside' && (
          <div className="hidden gap-3 md:flex">
            <PrevButton>
              <ChevronLeft width={18} />
            </PrevButton>
            <NextButton>
              <ChevronRight width={18} />
            </NextButton>
          </div>
        )}
        {dots && dotsPosition === 'outside' && <SliderScrollbar />}
      </div>
    </Swiper>
  );
};

export default Slider;
